import { ReactNode } from 'react';
import { useRecoilState } from 'recoil';
import { currentCenterModalState } from 'recoil/@common/centerModalState';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import styles from './CenterModal.module.scss';

interface IProps {
  children: ReactNode;
  isNativeVersion: boolean;
}
export default function CenterModal({ children }: IProps) {
  const [isOpenCenterModal, setIsOpenCenterModal] = useRecoilState(
    currentCenterModalState,
  );

  const outSideRef = useOnClickOutside(() => {
    setIsOpenCenterModal(false);
  });

  return (
    <>
      <section className={styles.overlay} />
      <section
        ref={outSideRef}
        className={styles.modalWrapper}
        data-active={isOpenCenterModal}
      >
        <div className={styles.content}>{children}</div>
      </section>
    </>
  );
}
